import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'

/**
 * Features section component - matching original kardstech.com design
 * Features: Six feature cards with proper icons and description
 */
const Features = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-50px" })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0, background: 'transparent' },
    visible: {
      y: 0,
      opacity: 1,
      background: 'transparent',
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  }

  const features = [
    {
      title: "Your Club Rules",
      description: "Choose any of our business models, full process management, attractive conditions for clubs.",
      image: "/icon_1.png"
    },
    {
      title: "Decentralized Finance (DeFi)",
      description: "With no central financial intermediaries such as brokerages, exchanges, or banks.",
      image: "/icon_2.png"
    },
    {
      title: "Bootcamp",
      description: "Launch friendly tables with participation control and full admin management control.",
      image: "/icon_3.png"
    },
    {
      title: "Easy Management",
      description: "Optimum control over clubs and users.",
      image: "/icon_4.png"
    },
    {
      title: "Best Support",
      description: "Your business works properly at all times.",
      image: "/icon_5.png"
    },
    {
      title: "Anti-fraud and Anti-bot",
      description: "Your business is secure from all kinds of online threats.",
      image: "/icon_6.png"
    }
  ]

  return (
    <section 
      id="features" 
      className="relative min-h-screen"
      style={{ backgroundColor: '#020d10' }}
      ref={ref}
    >
      <div style={{ 
        maxWidth: '1280px', 
        margin: '0 auto',
        padding: '64px 16px'
      }}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {/* Main Title */}
          <motion.div className="text-left mb-16" variants={itemVariants}>
            <h2 
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
              style={{
                fontFamily: 'Sequel100-65, sans-serif',
                textTransform: 'uppercase',
                lineHeight: '1.1'
              }}
            >
              <span style={{ color: '#ffffff' }}>HOST AND RUN </span>
              <span style={{ color: '#E5FF47' }}>PRIVATE</span>
              <br />
              <span style={{ color: '#E5FF47' }}>POKER CLUBS</span>
              <span style={{ color: '#ffffff' }}> AND</span>
              <br />
              <span style={{ color: '#ffffff' }}>YOUR OWN COMMUNITY</span>
            </h2>
            <p 
              className="text-lg text-gray-300 mb-8"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Turnkey features:
            </p>
          </motion.div>

          {/* Features Grid - 3x2 Layout */}
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto"
            variants={containerVariants}
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="text-left p-6"
                variants={itemVariants}
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <div className="mb-6">
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className="w-20 h-20 object-contain filter brightness-110"
                    style={{ filter: 'brightness(1.2) contrast(1.1)' }}
                  />
                </div>
                <h3 
                  className="text-xl font-semibold text-white mb-4"
                  style={{ 
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '600'
                  }}
                >
                  {feature.title}
                </h3>
                <p 
                  className="text-gray-300 leading-relaxed"
                  style={{ 
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '14px'
                  }}
                >
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </motion.div>

        </motion.div>
      </div>
    </section>
  )
}

export default Features
